<div class="sticky-loader">
  <div class="sticky-loader-inner">
    <div class="loader-ripple-icon" [ngClass]="{ 'white': whiteBg }"></div>
  </div>
</div>